import { IAudit, ITemplate } from '@alberta/konexi-shared';
import { TemplateDB } from 'src/app/common/repository/databases';
import { QueryService } from 'src/app/shared/services/query/query.service';

export async function evaluateWithEval(audit: IAudit, queryService: QueryService): Promise<boolean> {
  const template = (await queryService.get(audit.templateId, TemplateDB)) as ITemplate;
  if (!template) {
    return false;
  }
  if (template.templateTag?.toLocaleLowerCase() === 'vv ee') {
    return true;
  }
  return false;
}
